// ============================================================
// modeleWordFile.ts — téléchargements liés au modèle Word d'un template.
//
//   - modèle de départ : toujours les octets du .docx (généré par l'API)
//   - modèle actuel    : comme reportFile.ts, indépendant du driver backend —
//       driver s3    → JSON { url } (URL signée, nom d'origine via Content-Disposition)
//       driver local → les octets du fichier
// ============================================================

import api from '../reduxStore/api';

function declencherTelechargement(url: string, nom?: string): void {
  const a = document.createElement('a');
  a.href = url;
  if (nom) a.download = nom; // ignoré en cross-origin S3 → Content-Disposition prend le relais
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function telechargerBlob(blob: Blob, nom: string): void {
  const url = URL.createObjectURL(blob);
  declencherTelechargement(url, nom);
  URL.revokeObjectURL(url);
}

/** Message d'erreur lisible : en responseType blob, le JSON d'erreur arrive lui aussi en Blob. */
export async function messageErreurTelechargement(error: any): Promise<string> {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text());
      return json.error || json.message || 'Téléchargement impossible.';
    } catch { /* corps non JSON */ }
  }
  return 'Téléchargement impossible.';
}

/** Modèle Word de départ (toutes les balises), à personnaliser dans Word. */
export async function telechargerModeleDepart(): Promise<void> {
  const res = await api.get('/reportTemplate/modeleWord/depart', { responseType: 'blob' });
  telechargerBlob(res.data as Blob, 'modele_depart.docx');
}

/** Modèle Word actuellement enregistré pour un template (celui utilisé à l'impression). */
export async function telechargerModeleWordActuel(templateId: number, nom: string): Promise<void> {
  const res  = await api.get(`/reportTemplate/${templateId}/modeleWord`, { responseType: 'blob' });
  const blob = res.data as Blob;
  if (blob.type.includes('application/json')) {
    const { url } = JSON.parse(await blob.text());
    declencherTelechargement(url);
    return;
  }
  telechargerBlob(blob, nom);
}
